import { styled, Typography } from "@mui/material"

export const CloseButton = {
  width: "100%",
  fontSize: "17px",
  fontWeight: 500,
}

export const BankText = {
  margin: "20px 0 30px 0",
  textAlign: "center",
}

export const SourceDescription = styled(Typography)({
  width: 300,
  textAlign: "center",
  marginTop: 30,
})
